/*
 *  This file contains our graphics attributes such as color, line width, etc.
 */
var wsBlue = "#0d86d7";
var wsOrange = invertColor("#0d86d7"); //#f27928
var wsSteel = "#D14221";
var wsLightGray = "#526c7a";
var wsDarkGray = "#666666";

function invertColor(x) {
    var t1 = '0123456789abcdef#', t2 = 'fedcba9876543210#';
    x = x.replace( /./gi, function (s) { return t2.charAt(t1.indexOf(s));} );
    return x;
}

var selected_color = wsOrange; //inverse of a nice blue
var selected_attr = { fill: selected_color };

var stroke_width = 3;
var thin_stroke = 1;
var medium_stroke = 2;
var thick_stroke = 3;

var med_arrow_stroke = 2;
var big_arrow_stroke = 5;

//dashed line
var dashed_line_attr = {
    "stroke-dasharray": "--"
};
//icon attr
var icon_rect_attr = {
    //gradient: '90-#eeeeee-#ffffff',
    gradient: '90-#dddddd-#ffffff:30',
    stroke:"#526c7a",
    'stroke-width': 1
};

var icon_reflection_rect_attr = {
    fill: "#007BDE",
    stroke: "#007BDE"
};

//icon attr
var concrete_rect_attr = {
    //gradient: '90-#eeeeee-#ffffff',
    gradient: '90-#dddddd-#ffffff:30',
    stroke:wsDarkGray,
    'stroke-width': thick_stroke
};

var steel_shape_attr = {
    fill: "#A11500",
    stroke: wsDarkGray,
    'stroke-width': thin_stroke
};

//span
var steel_span_attr = {
    gradient: '90-#A11500-#D14221', //steel
    //gradient: '90-#0d86d7-#64a0c1', //light blue
    //gradient: '90-#0055CC-#45B5FF', //light blue
    //gradient: '90-#526c7a-#64a0c1',  //dark blue
    stroke: '#3b4449',
    'stroke-width': medium_stroke,
    'stroke-linejoin': 'round'
};

var wood_span_attr = {
    gradient: '90-#DBD87D-#FCF881', //wood
    //gradient: '90-#0d86d7-#64a0c1', //light blue
    //gradient: '90-#0055CC-#45B5FF', //light blue
    //gradient: '90-#526c7a-#64a0c1',  //dark blue
    stroke: '#3b4449',
    'stroke-width': medium_stroke,
    'stroke-linejoin': 'round'
};

var custom_shape_span_attr = {
    gradient: '90-#1E90FF-#00BFFF', //blue
    //gradient: '90-#0d86d7-#64a0c1', //light blue
    //gradient: '90-#0055CC-#45B5FF', //light blue
    //gradient: '90-#526c7a-#64a0c1',  //dark blue
    stroke: '#3b4449',
    'stroke-width': medium_stroke,
    'stroke-linejoin': 'round'
};

var span_attr = steel_span_attr;

//braces
var brace_attr = {
    stroke: '#0000FF',
    'stroke-width': medium_stroke
    //'stroke-linejoin': 'round'
};

//supports
var support_attr = {
    gradient: '90-#636363-#999999',
    stroke: '#3b4449',
    'stroke-width': medium_stroke,
    'stroke-linejoin': 'round'
};

var free_support_attr = {
    gradient: '90-#636363-#999999',
    stroke: '#3b4449',
    'stroke-width': medium_stroke,
    'stroke-linejoin': 'round',
    opacity:0.4
};

//load arrow attributes
var point_load_attr = {
    stroke: '#3b4449',
    'stroke-width': big_arrow_stroke
    //'stroke-linejoin': 'round'
};

//
var label_rect_attr = {
    //stroke: '#000000',
    fill : '#ffffff',
    'fill-opacity': 0.6,
    //'stroke-opacity': 0.0,
    //'stroke-width': med_arrow_stroke,
    'stroke-linejoin': 'round'
};

//distributed loads
var dist_load_arrow_attr = {
    stroke: '#3b4449',
    'stroke-width': med_arrow_stroke,
    'stroke-linejoin': 'round'
};

var dist_load_rect_attr = {
    stroke: '#3b4449',
    'stroke-width': med_arrow_stroke,
    fill : '#FAE284',
    opacity:0.75
};
